import { WidgetStatus } from '../widget-status';
import { StoreWidget } from '@pt/pt-models';

export class WidgetReducerUtils {

  static setWidgetState(widgets: StoreWidget[] | undefined, widgetStatus: WidgetStatus): StoreWidget[] {
    if (widgets) {
      const copy: StoreWidget[] = JSON.parse(JSON.stringify(widgets));
      return copy.map((storeWidget: StoreWidget) => {
        if (widgetStatus.internalId === storeWidget.internalId) {
          return {
            ...storeWidget,
            state: widgetStatus.state,
            isActivedEditMode: widgetStatus.activeEditMode,
            type: widgetStatus.type,
            previewData: widgetStatus.previewData
          } as StoreWidget;
        } else {
          return storeWidget;
        }
      })
    }
    return  [];

  }
}
